import React from 'react'
import { Grid } from 'semantic-ui-react'

import { translate } from 'loankeeper-common/helpers'

// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import PersonalInformation from './PersonalInformation'
import BusinessInformation from './BusinessInformation'
import IdentityInformation from './IdentityInformation'

import { isRequired } from '../../../helpers'

const FirstPage = ({
  fields,
  selects,
  dynamicOptions,
  noVisibilityFilter,
  onTranslateAltRequest,
  actionType,
  permissions,
  CRAImage,
  onChangeCRAImage,
  changeFormValue,
}) => (
  <GridContainer smallPadding>
    <Grid>
      <Grid.Row columns={2}>
        <PersonalInformation
          noVisibilityFilter={noVisibilityFilter}
          fields={fields}
          selects={selects}
          onTranslateAltRequest={onTranslateAltRequest}
        />

        <BusinessInformation
          noVisibilityFilter={noVisibilityFilter}
          fields={fields}
          selects={selects}
          dynamicOptions={dynamicOptions}
        />
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <IdentityInformation
            noVisibilityFilter={noVisibilityFilter}
            fields={fields}
            selects={selects}
            actionType={actionType}
            permissions={permissions}
            CRAImage={CRAImage}
            onChangeCRAImage={onChangeCRAImage}
            changeFormValue={changeFormValue}
          />

          <hr />
        </Grid.Column>
      </Grid.Row>

      {!!fields.Comment && (
        <Grid.Row columns={1}>
          <Grid.Column>
            <FormLayout
              visible={noVisibilityFilter || !!fields.Comment}
              label={translate('frm_client_ind-lbl_comment')}
            >
              <FormField
                name="Comment"
                type="textarea"
                required={isRequired(fields.Comment)}
                maxLength={fields.Comment && fields.Comment.MaxLen}
              />
            </FormLayout>
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  </GridContainer>
)

export default FirstPage
